/* src/app/user-role/user-role.component.scss */
.menuItem {
  max-width: 500px;
  background-color: whitesmoke;
  color: black;
}
/*# sourceMappingURL=user-role.component.css.map */
